<template>
  <div class="all-container">
    <div class="container-imgs">
      <img src="../../../assets/images/组 300.png" alt="">
      <img src="../../../assets/images/组 308.png" alt="">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/componets/footer/Footer"
export default {
  components: {
    Footer
  }
}
</script>

<style lang="less" scoped>
.all-container {
  width: 19.2rem;
  margin-top: 1.1rem;
}
.container-imgs {
  width: 12.84rem;
  margin-left: 3.18rem;
  margin-bottom: 0.78rem;
}
.container-imgs img {
  width: 4.28rem;
  height: 1.68rem;
}
</style>